var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHelpIcon = function SvgHelpIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10 0C4.75-.004.493 4.296.488 9.596.493 14.903 4.75 19.202 10 19.2c5.252.002 9.508-4.297 9.512-9.604-.004-5.3-4.26-9.6-9.512-9.596m0 16.989c-4.04 0-7.315-3.309-7.311-7.395-.004-4.076 3.271-7.384 7.31-7.382 4.042-.001 7.318 3.306 7.322 7.384-.004 4.084-3.28 7.393-7.321 7.393"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m9.199 12.355 1.742-.008V11c-.005-.365.165-.71.622-1.01s1.731-.907 1.733-2.507c-.002-1.594-1.34-2.691-2.466-2.929-1.124-.228-2.343-.076-3.206.876-.776.844-.94 1.515-.942 2.996h1.742V8.08c-.003-.787.088-1.62 1.212-1.85.618-.122 1.195.072 1.54.403.388.386.391 1.248-.235 1.675l-.978.665c-.568.369-.763.776-.764 1.371zm-.009 2.466v-1.783h1.759v1.783z"
  })));
};
export { SvgHelpIcon as ReactComponent };